import { render, staticRenderFns } from "./SegmentSummary.vue?vue&type=template&id=6207bbae&scoped=true&"
import script from "./SegmentSummary.vue?vue&type=script&lang=js&"
export * from "./SegmentSummary.vue?vue&type=script&lang=js&"
import style0 from "./SegmentSummary.vue?vue&type=style&index=0&id=6207bbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6207bbae",
  null
  
)

export default component.exports